import PropTypes from 'prop-types'
import { getWorkSkillIconSvg } from '../../../utils/workskills'
import { NameWithIcon } from './_Styled'
import { Caption1 } from '../../styled/typography/typography'

const WorkSkill = ({ workSkill, as='div', iconSize='17px', report=false }) => (
  <NameWithIcon
    as={as}
    icon={getWorkSkillIconSvg(workSkill)}
    iconSize={iconSize}
  >
    {report ? <Caption1 light>{workSkill.name}</Caption1>  : workSkill.name}
  </NameWithIcon>
)

WorkSkill.propTypes = {
  workSkill: PropTypes.object.isRequired,
  as: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  iconSize: PropTypes.string
}

export default WorkSkill
